import { ValidatedInput } from "./";
import sharedStyles from "../../shared.module.scss";
import { useFormatMessage } from "../../i18n";

export function VoiceControlPinForm({
  pin,
  handleChange,
  pristine,
  pinInputErrorMsg,
  handleSubmit,
}) {
  const tr = useFormatMessage();
  return (
    <form
      className={sharedStyles.form}
      style={{ textAlign: "left" }}
      onSubmit={(e) => {
        e.preventDefault();
        return handleSubmit();
      }}
    >
      <ValidatedInput
        label={tr("pin")}
        name={"pin"}
        id={"pin-input"}
        pristine={pristine}
        value={pin}
        onChange={handleChange}
        errors={pinInputErrorMsg}
      />
    </form>
  );
}
